<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Banner</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <sortableList v-model="items" axis="x">
              <sortableItem
                v-for="(item, index) in items"
                :index="index"
                :key="index"
                :item="item"
              />
            </sortableList>
          </CRow>
          <CRow alignHorizontal="end">
            <div class="button button-blue">UPDATE</div>
            <div style="width: 1.875rem" />
            <div class="button button-green">SAVE</div>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import sortableList from "../../banner/sortableList";
import sortableItem from "../../banner/sortableItem";
export default {
  name: "banner",
  components: {
    sortableList,
    sortableItem
  },
  data() {
    return {
      items: [
        {
          title: "TITLE1",
          expire: "00/00/000 - 00:00",
          img: require("@/assets/images/admin/course (1).png")
        },
        {
          title: "TITLE2",
          expire: "00/00/000 - 00:00",
          img: require("@/assets/images/admin/course (2).png")
        },
        {
          title: "TITLE3",
          expire: "00/00/000 - 00:00",
          img: require("@/assets/images/admin/course (3).png")
        },
        {
          title: "TITLE4",
          expire: "00/00/000 - 00:00",
          img: require("@/assets/images/admin/course (4).png")
        },
        {
          title: "TITLE5",
          expire: "00/00/000 - 00:00",
          img: require("@/assets/images/admin/course (5).png")
        }
      ]
    };
  },
  created() {
    $(document).ready(function() {
      var length = $(".cards-banner").length;

      $(".cards-banner").css("z-index", function(i) {
        return length - i;
      });
    });
  }
};
</script>

